import { useState, useEffect } from 'react';

import { Button, useToast } from '@chakra-ui/react';
import { HttpStatusCode } from 'axios';

import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, DURATION_TOAST, COLORS } from '@/common/constants';
import { useAppSelector } from '@/redux/hooks';
import { RootState } from '@/redux/store';
import { getListSireReviewsSimpleByInvoice } from '@/services/InvoiceSireReviewReviewerService';
import TableSireReviewSimple, { SireDataSimple } from '@/components/Tables/TableSireReviewSimple';
import { getListSireReviewsSimpleByRequestorInvoice, SireReviewSimpleRequestor } from '@/services/InvoiceSireReviewRequestorService';
import { useLocation } from 'react-router-dom';

const InvoicesLinkedSireReviews = () => {
    const role = useAppSelector((state: RootState) => state.account.roleName);
    const toast = useToast();

    const location = useLocation();
    const { id, isRequestor } = location.state || {};

    const [currentPageNumber, setCurrentPageNumber] = useState(DEFAULT_PAGE_NUMBER);
    const [currentPageSize, setCurrentPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [dataList, setDataList] = useState<SireDataSimple[]>([]);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [totalPageNumber, setTotalPageNumber] = useState(1);

    const getData = async () => {
        let response = {} as any;

        if (isRequestor){
            response = await getListSireReviewsSimpleByRequestorInvoice(id, currentPageNumber, currentPageSize);
        } else {
            response = await getListSireReviewsSimpleByInvoice(id, currentPageNumber, currentPageSize);
        }

        if (response.status === HttpStatusCode.Ok) {
            const originalData = response.data;
            const transformedData = originalData.map((data: SireReviewSimpleRequestor) => ({
                ...data,
                addaldPertamina: data.addAldPertamina,
                requestor: data.requestorName,
            })) as SireDataSimple[];
            setDataList(transformedData);
            setTotalPageNumber(response.totalPage);
            setCurrentPageNumber(response.pageNumber);
            setHasNextPage(response.hasNextPage);
        } else {
            toast({
                title: response?.error?.code,
                description: response?.error?.message,
                status: 'error',
                duration: DURATION_TOAST,
                isClosable: true,
            });
        }

        setIsLoading(false);
    }

    const handleBack = () => {
        history.back()
    }

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        getData();
    }, [currentPageSize, currentPageNumber])

    return (
        <>
            <div style={{ padding: 30 }}>
            <Button px={8} bgColor={COLORS.BUTTON.BACKGROUND} color={COLORS.BUTTON.FOREGROUND} variant='solid' borderRadius={10} onClick={handleBack} style={{ marginBottom: 20 }}>Back</Button>
                <TableSireReviewSimple
                    dataList={dataList}
                    isLoading={isLoading}
                    role={role}
                    currentPageNumber={currentPageNumber}
                    currentPageSize={currentPageSize}
                    handleChangePageNumber={setCurrentPageNumber}
                    handleChangePageSize={setCurrentPageSize}
                    hasNextPage={hasNextPage}
                    totalPageNumber={totalPageNumber}
                />
            </div>
        </>
    )
}

export default InvoicesLinkedSireReviews;
